export const GROUP_MONTH_DATE_FORMAT = 'yyyyMMdd'
export const LABEL_MONTH_DATE_FORMAT = 'MMMM'
export const LABEL_MONTH_DATE_FORMAT_WITH_YEAR = 'MMMM yyyy'
export const TODAY_LABEL_ASC = '00000000'
export const TODAY_LABEL_DESC = '99999999'
export const NO_EVENTS_ICON_SIZE = 80
